import { styled } from '@mui/material/styles';

import { DataRowWrapper } from 'shared/components/DataRow';

export const Wrapper = styled(DataRowWrapper)(({ theme }) => ({
  alignSelf: 'start',

  [theme.breakpoints.up('xl')]: {
    gridTemplateColumns: '1fr',
  },
}));
